import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sv2-visual"
}
const _hoisted_2 = { class: "sv2-visual__logo-row" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Ditto", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-visual__lead" }, " The easiest way to share screens and display digital signage across your organization. ", -1)
const _hoisted_6 = { class: "sv2-visual__features" }
const _hoisted_7 = { class: "sv2-visual__feature" }
const _hoisted_8 = { class: "sv2-visual__feature-icon" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Screen Sharing", -1)
const _hoisted_10 = { class: "sv2-visual__feature" }
const _hoisted_11 = { class: "sv2-visual__feature-icon" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Digital Signage", -1)
const _hoisted_13 = { class: "sv2-visual__feature" }
const _hoisted_14 = { class: "sv2-visual__feature-icon" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Emergency Alerts", -1)
const _hoisted_16 = {
  key: 1,
  class: "sv2-visual"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<p class=\"sv2-visual__lead\">Tell us about your organization so we can tailor your setup experience.</p><div class=\"sv2-visual__stats\"><div class=\"sv2-visual__stat\"><div class=\"sv2-visual__stat-value\">30</div><div class=\"sv2-visual__stat-label\">Day free trial</div></div><div class=\"sv2-visual__stat\"><div class=\"sv2-visual__stat-value\">Unlimited</div><div class=\"sv2-visual__stat-label\">Receivers</div></div></div>", 2)
const _hoisted_19 = {
  key: 2,
  class: "sv2-visual"
}
const _hoisted_20 = { class: "sv2-visual__circle" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-visual__lead" }, "Secure your account. You are one step away from the Ditto portal.", -1)
const _hoisted_22 = {
  key: 3,
  class: "sv2-visual"
}
const _hoisted_23 = { class: "sv2-visual__circle" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-visual__title" }, "Check your inbox", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-visual__small" }, " Open the verification email we sent to confirm your email address. ", -1)
const _hoisted_26 = {
  key: 4,
  class: "sv2-visual"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", {
  class: "sv2-visual__lead",
  style: {"font-size":"16px","max-width":"320px"}
}, " Find the room code on a Ditto display, enter it here, and start sharing. ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-visual__small" }, "No accounts. Just the code shown on the display.", -1)
const _hoisted_30 = {
  key: 5,
  class: "sv2-visual"
}
const _hoisted_31 = { class: "sv2-visual__circle" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-visual__lead" }, " We'll send your admin an overview, a deployment guide, and a free trial — everything they need to bring Ditto to your team. ", -1)
const _hoisted_33 = {
  key: 6,
  style: {"position":"relative","width":"100%","height":"100%"}
}
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = { style: {"position":"absolute","inset":"0","display":"flex","flex-direction":"column","align-items":"center","justify-content":"center","gap":"24px","padding":"0 48px"} }
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"28px","font-weight":"600","color":"#fff","letter-spacing":"-0.01em","text-align":"center","margin":"0"} }, " Main Conference Room ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ph_broadcast = _resolveComponent("ph-broadcast")!
  const _component_ph_chalkboard_teacher = _resolveComponent("ph-chalkboard-teacher")!
  const _component_ph_siren = _resolveComponent("ph-siren")!
  const _component_ph_buildings = _resolveComponent("ph-buildings")!
  const _component_ph_lock = _resolveComponent("ph-lock")!
  const _component_ph_envelope_open = _resolveComponent("ph-envelope-open")!
  const _component_ph_paper_plane_tilt = _resolveComponent("ph-paper-plane-tilt")!

  return (_ctx.screen === 'about-you')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.logoLight,
            alt: "Ditto",
            width: "40",
            height: "40"
          }, null, 8, _hoisted_3),
          _hoisted_4
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ph_broadcast, {
                size: 28,
                weight: "fill"
              })
            ]),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_ph_chalkboard_teacher, {
                size: 28,
                weight: "fill"
              })
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_ph_siren, {
                size: 28,
                weight: "fill"
              })
            ]),
            _hoisted_15
          ])
        ])
      ]))
    : (_ctx.screen === 'organization')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_ph_buildings, {
            size: 64,
            weight: "fill",
            style: {"color":"rgba(255, 255, 255, 0.8)"}
          }),
          _hoisted_17
        ]))
      : (_ctx.screen === 'account')
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_ph_lock, {
                size: 40,
                weight: "fill"
              })
            ]),
            _hoisted_21
          ]))
        : (_ctx.screen === 'verify-email')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_ph_envelope_open, {
                  size: 40,
                  weight: "fill"
                })
              ]),
              _hoisted_24,
              _hoisted_25
            ]))
          : (_ctx.screen === 'use-ditto')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("img", {
                  src: _ctx.logoLight,
                  alt: "Ditto",
                  width: "80",
                  height: "80"
                }, null, 8, _hoisted_27),
                _hoisted_28,
                _hoisted_29
              ]))
            : (_ctx.screen === 'tell-admin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_ph_paper_plane_tilt, {
                      size: 40,
                      weight: "fill"
                    })
                  ]),
                  _hoisted_32
                ]))
              : (_ctx.screen === 'connect-room')
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["sv2-brand-fade", { 'sv2-brand-fade--hidden': _ctx.branded }]),
                      style: {"display":"flex","align-items":"center","justify-content":"center"}
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.logoLight,
                        alt: "Ditto",
                        width: "160",
                        height: "160"
                      }, null, 8, _hoisted_34)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["sv2-brand-fade", { 'sv2-brand-fade--hidden': !_ctx.branded }]),
                      style: {"background":"#000"}
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.customBg,
                        alt: "",
                        style: {"position":"absolute","inset":"0","width":"100%","height":"100%","object-fit":"cover"}
                      }, null, 8, _hoisted_35),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("img", {
                          src: _ctx.strideLogo,
                          alt: "StrideUX",
                          style: {"width":"100%","max-width":"280px","height":"auto"}
                        }, null, 8, _hoisted_37),
                        _hoisted_38
                      ])
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
}